import type { AreaKey } from '@exigo/shared';
import { Tabs } from '../../components/ui/Tabs';
import type { ReferenceData } from '../../api/types';

interface AreaTabsProps {
  value: AreaKey;
  onChange: (area: AreaKey) => void;
  reference: ReferenceData;
}

/** The four solution areas. Switching areas changes which engagements and input fields apply. */
export function AreaTabs({ value, onChange, reference }: AreaTabsProps): React.JSX.Element {
  return (
    <Tabs
      value={value}
      onChange={(v) => { onChange(v as AreaKey); }}
      ariaLabel="Solution area"
      items={reference.areas.map((a) => ({ value: a.key, label: a.name, sub: a.sub }))}
    />
  );
}
